import EventApi from '@apis/event/EventApi';
import couponQueries from '@apis/queries/couponQueries';
import eventQueries from '@apis/queries/eventQueries';
import useToast from '@hooks/ui/useToast';
import { ErrorResponse } from '@models/error';
import { AttendanceCheckInType } from '@models/event';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

function useAttendanceCheck(eventId: string, checkInType: AttendanceCheckInType) {
    const { t } = useTranslation('event');
    const queryClient = useQueryClient();
    const toast = useToast();

    const { mutate } = useMutation({
        mutationFn() {
            return EventApi.attendanceCheckIn(eventId, checkInType);
        },
        onSuccess() {
            queryClient.invalidateQueries({ queryKey: eventQueries.attendanceProgress._def });
            queryClient.invalidateQueries({ queryKey: couponQueries._def });
            toast.success(t('attendance.success'));
        },
        onError(e:AxiosError<ErrorResponse>) {
            switch (e.response?.status) {
            case 409:
                toast.error(t('attendance.alreadyChecked'));
                break;
            default:
                console.error(e);
                toast.error(t('attendance.unknownError'));
            }
        },
    });

    return () => mutate();
}

export default useAttendanceCheck;
